module.exports = __webpack_public_path__ + "fonts/Inter-800-latin59.5eb4a77.woff2";